export default __webpack_public_path__ + "static/media/about-02.be047dab.jpg";